module.exports = __webpack_public_path__ + "static/media/Carrot_soup.a65135d5.png";